import { render, staticRenderFns } from "./BookShopDailyManage.vue?vue&type=template&id=f87862a6&scoped=true"
import script from "./BookShopDailyManage.vue?vue&type=script&lang=js"
export * from "./BookShopDailyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87862a6",
  null
  
)

export default component.exports